import axiosInstance from "./axiosInstance";

const deletePost = async (postId: number) => {
  const accessToken = localStorage.getItem("accessTokenGC");

  if (!accessToken) {
    throw new Error("No access token found");
  }

  try {
    const response = await axiosInstance.delete(`/api/posts/${postId}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error: unknown) {
    let errorMessage = "Error deleting post. Try again.";

    if (error instanceof Error) {
      errorMessage = error.message;
    }

    if (typeof error === "object" && error !== null) {
      const err = error as {response?: {data?: {message?: string}}};
      errorMessage = err.response?.data?.message || errorMessage;
    }

    throw new Error(errorMessage);
  }
};

export default deletePost;
